;"use strict";

import State from './state';
//import MainData from './maindata';
//import CustUK from './custuk';

class MainTable {

	constructor() {
		$('#xls-button').on(State.startEvent, (e) => showSetupPanel(e));
		$('#reg-button').on(State.startEvent, (e) => this.changeReg(e));
		// State.calc.fillKsgBuf();
		// this.render();
	}

//////////////////////////////

	changeReg() {

		State.regSelector.showRegs();
	}

//////////////////////////////

	render() {

        let tableCode = ``, lineTemplate, color = 1, colorClass, dsCode, stCode,
        	dsVal, stVal, cnt, stCnt = 0, dsCnt = 0;                
        let nOfLines = State.dsList.length;

        if(State.stList.length>nOfLines) nOfLines = State.stList.length;
        for(cnt=0 ; cnt<nOfLines ; cnt++) {
        	if(color==1) colorClass = 'grey';
        	else colorClass = '';
        	if(State.dsList[dsCnt]) {
        		dsCode = State.dsList[dsCnt];
        		dsVal = Math.round(State.dsBuf[dsCode]*100)/100;
        		dsVal = State.calc.padFloat(dsVal); 
        	} else {
        		dsCode = '';
        		dsVal = '';
        	}
        	if(State.stList[stCnt]) {
        		stCode = State.stList[stCnt];
// Блокируем показ удаленных КСГ
				if(-1!=stCode.indexOf('st23.004.')) {stCnt++;  continue;} 
        		stVal =  Math.round(State.stBuf[stCode]*100)/100;
        		stVal = State.calc.padFloat(stVal); 
        	} else {
        		stCode = '';
        		stVal = '';
        	}
			lineTemplate = 
                `<div class="scr3-line" id="scr3-line1">
			        <div class="scr3-col t-col1 ${colorClass}" id="col1-line1">${dsCode}</div>
			        <div class="scr3-col t-col2 ${colorClass}" id="col2-line1">${dsVal}</div>
			        <div class="scr3-col t-col3 ${colorClass}" id="col3-line1">${stCode}</div>
			        <div class="scr3-col t-col4 ${colorClass}" id="col4-line1">${stVal}</div>
    			</div>
			`;
            tableCode += lineTemplate;
            dsCnt++; stCnt++;    
//			color++; if (color>1) color = 0;	
        }

 		$('#scr3-insert').html(tableCode);
 		$('.curr-region').text(State.currRegname);
 		if(State.currRegname.length>36) $('#scr3-region').css({'top':'47px'});
 		else $('#scr3-region').css({'top':'75px'});
 			
	}

//////////////////////////////

	renderXlsLines() {

		let cnt, lineTemplate, tableCode = '', dsCode, dsVal, stCode, stVal, 
			stCnt = 0, dsCnt = 0; 
				
		let len = State.dsList.length;
		if(len<State.stList.length) len = State.stList.length;
		for(cnt=0 ; cnt<len ; cnt++) {
        	if(State.dsList[dsCnt]) {
        		dsCode = State.dsList[dsCnt];
        		dsVal = Math.round(State.dsBuf[dsCode]*100)/100;
        	} else {
        		dsCode = '';
        		dsVal = '';
        	}
        	if(State.stList[stCnt]) {
        		stCode = State.stList[stCnt];
// Блокируем показ удаленных КСГ
				if(-1!=stCode.indexOf('st23.004.')) { stCnt++; continue; } 
        		stVal =  Math.round(State.stBuf[stCode]*100)/100;
        	} else {
        		stCode = '';
        		stVal = '';
        	}
            lineTemplate = `<Row ss:AutoFitHeight="0" ss:Height="17.0625">
		    <Cell ss:Index="2" ss:StyleID="s46"><Data ss:Type="String">${dsCode}</Data></Cell>
		    <Cell ss:StyleID="s47"><Data ss:Type="Number">${dsVal}</Data></Cell>
		    <Cell ss:StyleID="s46"><Data ss:Type="String">${stCode}</Data></Cell>
		    <Cell ss:StyleID="s47"><Data ss:Type="Number">${stVal}</Data></Cell>
		   </Row>`;    
            tableCode += lineTemplate;
            stCnt++; dsCnt++;    
		}

		return tableCode;
	}

//////////////////////////////


	renderFirstXls() {

		let tableStr, tabHeader;
		 



		tabHeader = `
		<?xml version="1.0"?>
		<?mso-application progid="Excel.Sheet"?>
		<Workbook xmlns="urn:schemas-microsoft-com:office:spreadsheet"
		 xmlns:o="urn:schemas-microsoft-com:office:office"
		 xmlns:x="urn:schemas-microsoft-com:office:excel"
		 xmlns:ss="urn:schemas-microsoft-com:office:spreadsheet"
		 xmlns:html="http://www.w3.org/TR/REC-html40">
		 <DocumentProperties xmlns="urn:schemas-microsoft-com:office:office">
		  <Author>Microsoft Corporation</Author>
		  <LastAuthor>Alex</LastAuthor>
		  <Created>1996-10-08T23:32:33Z</Created>
		  <LastSaved>2020-01-15T21:33:17Z</LastSaved>
		  <Version>11.5606</Version>
		 </DocumentProperties>
		 <ExcelWorkbook xmlns="urn:schemas-microsoft-com:office:excel">
		  <WindowHeight>7320</WindowHeight>
		  <WindowWidth>9720</WindowWidth>
		  <WindowTopX>120</WindowTopX>
		  <WindowTopY>120</WindowTopY>
		  <AcceptLabelsInFormulas/>
		  <ProtectStructure>False</ProtectStructure>
		  <ProtectWindows>False</ProtectWindows>
		  <DisplayInkNotes>False</DisplayInkNotes>
		 </ExcelWorkbook>
		 <Styles>
		  <Style ss:ID="Default" ss:Name="Normal">
		   <Alignment ss:Vertical="Bottom"/>
		   <Borders/>
		   <Font/>
		   <Interior/>
		   <NumberFormat/>
		   <Protection/>
		  </Style>
		  <Style ss:ID="s16" ss:Name="Финансовый">
		   <NumberFormat ss:Format="_(* #,##0.00_);_(* \(#,##0.00\);_(* &quot;-&quot;??_);_(@_)"/>
		  </Style>
		  <Style ss:ID="s23">
		   <Font ss:Size="14"/>
		  </Style>
		  <Style ss:ID="s26">
		   <Font ss:Size="12"/>
		  </Style>
		  <Style ss:ID="s42">
		   <Font x:CharSet="204" x:Family="Swiss" ss:Size="13"/>
		  </Style>
		  <Style ss:ID="s43">
		   <Alignment ss:Horizontal="Left" ss:Vertical="Bottom"/>
		   <Font ss:Size="12"/>
		  </Style>
		  <Style ss:ID="s46">
		   <Alignment ss:Horizontal="Center" ss:Vertical="Bottom"/>
		   <Borders>
		    <Border ss:Position="Bottom" ss:LineStyle="Continuous" ss:Weight="1"/>
		    <Border ss:Position="Left" ss:LineStyle="Continuous" ss:Weight="1"/>
		    <Border ss:Position="Right" ss:LineStyle="Continuous" ss:Weight="1"/>
		    <Border ss:Position="Top" ss:LineStyle="Continuous" ss:Weight="1"/>
		   </Borders>
		  </Style>
		  <Style ss:ID="s47" ss:Parent="s16">
		   <Borders>
		    <Border ss:Position="Bottom" ss:LineStyle="Continuous" ss:Weight="1"/>
		    <Border ss:Position="Left" ss:LineStyle="Continuous" ss:Weight="1"/>
		    <Border ss:Position="Right" ss:LineStyle="Continuous" ss:Weight="1"/>
		    <Border ss:Position="Top" ss:LineStyle="Continuous" ss:Weight="1"/>
		   </Borders>
		  </Style>
		  <Style ss:ID="s48">
		   <Alignment ss:Horizontal="Center" ss:Vertical="Bottom"/>
		   <Borders>
		    <Border ss:Position="Bottom" ss:LineStyle="Continuous" ss:Weight="1"/>
		    <Border ss:Position="Left" ss:LineStyle="Continuous" ss:Weight="1"/>
		    <Border ss:Position="Right" ss:LineStyle="Continuous" ss:Weight="1"/>
		    <Border ss:Position="Top" ss:LineStyle="Continuous" ss:Weight="1"/>
		   </Borders>
		   <Font x:CharSet="204" x:Family="Swiss" ss:Bold="1"/>
		  </Style>
		 </Styles>
		 <Worksheet ss:Name="Стоимость терапии">
		  <Table x:FullColumns="1"
		   x:FullRows="1">
		   <Column ss:Index="2" ss:AutoFitWidth="0" ss:Width="89.25"/>
		   <Column ss:AutoFitWidth="0" ss:Width="94.5"/>
		   <Column ss:AutoFitWidth="0" ss:Width="75"/>
		   <Column ss:AutoFitWidth="0" ss:Width="93.75"/>
		   <Row ss:Index="2" ss:Height="18">
		    <Cell ss:Index="2" ss:StyleID="s23"><Data ss:Type="String">Стоимость клинического случая по тарифам ОМС</Data></Cell>
		   </Row>
		   <Row ss:AutoFitHeight="0" ss:Height="20.25">
		    <Cell ss:Index="2" ss:StyleID="s42"><Data ss:Type="String">Неонкологические заболевания</Data></Cell>
		    <Cell ss:StyleID="s26"/>
		   </Row>
		   <Row ss:AutoFitHeight="0" ss:Height="21.75">
		    <Cell ss:Index="2" ss:StyleID="s43"><Data ss:Type="String">Регион: ${State.currRegname}</Data></Cell>
		    <Cell ss:StyleID="s26"/>
		   </Row>
		   <Row ss:AutoFitHeight="0" ss:Height="10.5">
		    <Cell ss:Index="2" ss:StyleID="s43"/>
		    <Cell ss:StyleID="s26"/>
		   </Row>
		   <Row ss:AutoFitHeight="0" ss:Height="20.25">
		    <Cell ss:Index="2" ss:MergeAcross="1" ss:StyleID="s48"><Data ss:Type="String">Дневной стационар</Data></Cell>
		    <Cell ss:MergeAcross="1" ss:StyleID="s48"><Data ss:Type="String">Круглосуточный стационар</Data></Cell>
		   </Row>
		   <Row ss:AutoFitHeight="0" ss:Height="18.75">
		    <Cell ss:Index="2" ss:StyleID="s48"><Data ss:Type="String">КСГ</Data></Cell>
		    <Cell ss:StyleID="s48"><Data ss:Type="String">Стоимость руб.</Data></Cell>
		    <Cell ss:StyleID="s48"><Data ss:Type="String">КСГ</Data></Cell>
		    <Cell ss:StyleID="s48"><Data ss:Type="String">Стоимость руб.</Data></Cell>
		   </Row>`;

			let tabFooter = `  
				  </Table>
				  <WorksheetOptions xmlns="urn:schemas-microsoft-com:office:excel">
				   <PageSetup>
				    <PageMargins x:Bottom="0.984251969" x:Left="0.78740157499999996"
				     x:Right="0.78740157499999996" x:Top="0.984251969"/>
				   </PageSetup>
				   <Print>
				    <ValidPrinterInfo/>
				    <PaperSizeIndex>9</PaperSizeIndex>
				    <HorizontalResolution>1200</HorizontalResolution>
				    <VerticalResolution>1200</VerticalResolution>
				   </Print>
				   <Selected/>
				   <Panes>
				    <Pane>
				     <Number>3</Number>
				     <ActiveRow>13</ActiveRow>
				    </Pane>
				   </Panes>
				   <ProtectObjects>False</ProtectObjects>
				   <ProtectScenarios>False</ProtectScenarios>
				  </WorksheetOptions>
				 </Worksheet>
				</Workbook>
				`;   

		let linesStr = '';
		linesStr += this.renderXlsLines();

		tableStr = tabHeader + linesStr;
		tableStr += tabFooter;

        let blob = new Blob([tableStr], { type: 'application/vnd.ms-excel' });
        let link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'Тарифы региона.xls';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
	}

//////////////////////////////

	regCompare(a, b) {

		let name1 = a.name,
			name2 = b.name;
			if(name1>name2)	return 1;	
			if(name1<name2)	return -1;
			return 0;	
	}

//////////////////////////////

	renderRegLines() {

		let reg, len, cnt, regName, bs_ds, bs_ks, kus_ds, kus_ks, groupStr = '',
			tableStr = '', ksgStr = '', ksgLen, ksg, ksgVal, regId, custUkSet, ukVal,
			regData, tarif;
		let regList = [];	
			
    	len = State.MainData.length;
    	for(cnt=0 ; cnt<len ; cnt++) regList.push(State.MainData[cnt]);
    	regList.sort(this.regCompare);	
    	for(cnt=0 ; cnt<len ; cnt++) { // Цикл по регионам
    		regData = regList[cnt];
    		regId = regData.id;
    		regName = regData.name;
    		bs_ds = regData.bs_ds;
    		bs_ks = regData.bs_ks;
    		kus_ds = regData.kus_ds;
    		kus_ks = regData.kus_ks;
    		groupStr = '';
	    	let lineStr = `
	        <Row ss:AutoFitHeight="0" ss:Height="18">
		    <Cell ss:Index="2" ss:StyleID="s22"><Data ss:Type="String">${regName}</Data></Cell>
		    <Cell ss:StyleID="s26"><Data ss:Type="Number">${bs_ds}</Data></Cell>
		    <Cell ss:StyleID="s26"><Data ss:Type="Number">${bs_ks}</Data></Cell>
		    <Cell ss:StyleID="s22"><Data ss:Type="Number">${kus_ds}</Data></Cell>
		    <Cell ss:StyleID="s22"><Data ss:Type="Number">${kus_ks}</Data></Cell>
			`;
			ksgLen = State.dsList.length;
			for(let i=0 ; i<ksgLen ; i++) { // Цикл по DS KSG
				ksg = State.dsList[i];
				ksgVal = State.calc.getKsgValue(ksg);
				ukVal = 0;
				if(State.CustUK[regId]) {
					custUkSet = State.CustUK[regId];
					if(custUkSet[ksg]) ukVal = custUkSet[ksg];
				}
				if(ukVal==0) { // Для данного региона и текущего КСГ нет индивидуального значения
					ukVal = regData.uk_ds;
				}
if(ukVal==undefined) console.log(regData.name);
				tarif = State.calc.calcIncome(regData, ksg);
				tarif = Math.round(tarif*100)/100;
				ksgStr = `
					<Cell ss:StyleID="s22"><Data ss:Type="Number">${ksgVal}</Data></Cell>
					<Cell ss:StyleID="s22"><Data ss:Type="Number">${ukVal}</Data></Cell>
					<Cell ss:StyleID="s26"><Data ss:Type="Number">${tarif}</Data></Cell>
					`;
				groupStr += ksgStr;	    
			}
			ksgLen = State.stList.length;
			for(let i=0 ; i<ksgLen ; i++) { // Цикл по ST KSG
				ksg = State.stList[i];
 // Блокируем показ удаленных КСГ
				if(-1!=ksg.indexOf('st23.004.')) continue; 
				ksgVal = State.calc.getKsgValue(ksg);
				ukVal = 0;
				if(State.CustUK[regId]) {
					custUkSet = State.CustUK[regId];
					if(custUkSet[ksg]) ukVal = custUkSet[ksg];
				}
				if(ukVal==0) { // Для данного региона и текущего КСГ нет индивидуального значения
					ukVal = regData.uk_ks;
				}
if(ukVal==undefined) console.log(regData.name);
				tarif = State.calc.calcIncome(regData, ksg);
				tarif = Math.round(tarif*100)/100;
				ksgStr = `
					<Cell ss:StyleID="s22"><Data ss:Type="Number">${ksgVal}</Data></Cell>
					<Cell ss:StyleID="s22"><Data ss:Type="Number">${ukVal}</Data></Cell>
					<Cell ss:StyleID="s26"><Data ss:Type="Number">${tarif}</Data></Cell>
					`;
				groupStr += ksgStr;	    
			}
			lineStr += groupStr;
			lineStr += '</Row>'
			tableStr += lineStr;
    	}
	    return tableStr;	
	}

//////////////////////////////

	renderHeders() {

		var headerBlock, cnt, len, str, hstr = '', ksg;
		var widthTemplate = `
		   <Column ss:AutoFitWidth="0" ss:Width="91.5"/>
		   <Column ss:AutoFitWidth="0" ss:Width="120"/>
		   <Column ss:AutoFitWidth="0" ss:Width="142.5"/>
		`;
		var titleStr = `
		   <Row ss:AutoFitHeight="0" ss:Height="30">
		    <Cell ss:Index="3" ss:StyleID="s23"><Data ss:Type="String">Сводная таблица тарифов ОМС по регионам</Data></Cell>
		    <Cell ss:Index="8" ss:StyleID="s24"/>
		   </Row>
		   <Row ss:AutoFitHeight="0" ss:Height="15.75"/>
		   <Row ss:AutoFitHeight="0" ss:Height="18">
		    <Cell ss:Index="2" ss:StyleID="s27"><Data ss:Type="String">Регион</Data></Cell>
		    <Cell ss:StyleID="s27"><Data ss:Type="String">Базовая ставка ДС</Data></Cell>
		    <Cell ss:StyleID="s27"><Data ss:Type="String">Базовая ставка КС</Data></Cell>
		    <Cell ss:StyleID="s27"><Data ss:Type="String">КУС ДС</Data></Cell>
		    <Cell ss:StyleID="s27"><Data ss:Type="String">КУС КС</Data></Cell>
		`;
		len = State.dsList.length + State.stList.length;
		for(cnt=0 ; cnt<len ; cnt++) hstr += widthTemplate;
		hstr += titleStr;
		len = State.dsList.length;
		for(cnt=0 ; cnt<len ; cnt++) {
			ksg = State.dsList[cnt];
			str = `
			<Cell ss:StyleID="s27"><Data ss:Type="String">КСГ № ${ksg}</Data></Cell>
		    <Cell ss:StyleID="s27"><Data ss:Type="String">КС к КСГ № ${ksg}</Data></Cell>
		    <Cell ss:StyleID="s27"><Data ss:Type="String">Тариф по КСГ № ${ksg}</Data></Cell>
		    `;
			hstr += str;    
		}	
		len = State.stList.length;
		for(cnt=0 ; cnt<len ; cnt++) {
			ksg = State.stList[cnt];
 // Блокируем показ удаленных КСГ
			if(-1!=ksg.indexOf('st23.004.')) continue; 
			str = `
			<Cell ss:StyleID="s27"><Data ss:Type="String">КСГ № ${ksg}</Data></Cell>
		    <Cell ss:StyleID="s27"><Data ss:Type="String">КС к КСГ № ${ksg}</Data></Cell>
		    <Cell ss:StyleID="s27"><Data ss:Type="String">Тариф по КСГ № ${ksg}</Data></Cell>
		    `;
			hstr += str;    
		}	
		hstr += '</Row>';
		return hstr;	
	}

//////////////////////////////

	renderSecondXls() {

		let tableStr, tabHeader;
		 
		const tabHeader1 = `
			<?xml version="1.0"?>
			<?mso-application progid="Excel.Sheet"?>
			<Workbook xmlns="urn:schemas-microsoft-com:office:spreadsheet"
			 xmlns:o="urn:schemas-microsoft-com:office:office"
			 xmlns:x="urn:schemas-microsoft-com:office:excel"
			 xmlns:ss="urn:schemas-microsoft-com:office:spreadsheet"
			 xmlns:html="http://www.w3.org/TR/REC-html40">
			 <DocumentProperties xmlns="urn:schemas-microsoft-com:office:office">
			  <Author>Microsoft Corporation</Author>
			  <LastAuthor>Alex</LastAuthor>
			  <Created>1996-10-08T23:32:33Z</Created>
			  <LastSaved>2020-01-21T18:53:07Z</LastSaved>
			  <Version>11.5606</Version>
			 </DocumentProperties>
			 <ExcelWorkbook xmlns="urn:schemas-microsoft-com:office:excel">
			  <WindowHeight>7320</WindowHeight>
			  <WindowWidth>9720</WindowWidth>
			  <WindowTopX>120</WindowTopX>
			  <WindowTopY>120</WindowTopY>
			  <AcceptLabelsInFormulas/>
			  <ProtectStructure>False</ProtectStructure>
			  <ProtectWindows>False</ProtectWindows>
			  <DisplayInkNotes>False</DisplayInkNotes>
			 </ExcelWorkbook>
			 <Styles>
			  <Style ss:ID="Default" ss:Name="Normal">
			   <Alignment ss:Vertical="Bottom"/>
			   <Borders/>
			   <Font/>
			   <Interior/>
			   <NumberFormat/>
			   <Protection/>
			  </Style>
			  <Style ss:ID="s19" ss:Name="Финансовый">
			   <NumberFormat ss:Format="_(* #,##0.00_);_(* \(#,##0.00\);_(* &quot;-&quot;??_);_(@_)"/>
			  </Style>
			  <Style ss:ID="s21">
			   <Borders>
			    <Border ss:Position="Bottom" ss:LineStyle="Continuous" ss:Weight="1"/>
			    <Border ss:Position="Left" ss:LineStyle="Continuous" ss:Weight="1"/>
			    <Border ss:Position="Right" ss:LineStyle="Continuous" ss:Weight="1"/>
			    <Border ss:Position="Top" ss:LineStyle="Continuous" ss:Weight="1"/>
			   </Borders>
			   <Font x:CharSet="204" x:Family="Swiss" ss:Bold="1"/>
			  </Style>
			  <Style ss:ID="s22">
			   <Borders>
			    <Border ss:Position="Bottom" ss:LineStyle="Continuous" ss:Weight="1"/>
			    <Border ss:Position="Left" ss:LineStyle="Continuous" ss:Weight="1"/>
			    <Border ss:Position="Right" ss:LineStyle="Continuous" ss:Weight="1"/>
			    <Border ss:Position="Top" ss:LineStyle="Continuous" ss:Weight="1"/>
			   </Borders>
			  </Style>
			  <Style ss:ID="s23">
			   <Font x:CharSet="204" x:Family="Swiss" ss:Size="16" ss:Bold="1"/>
			  </Style>
			  <Style ss:ID="s24">
			   <Font x:CharSet="204" x:Family="Swiss" ss:Size="14" ss:Color="#FF0000"
			    ss:Bold="1"/>
			   <Interior/>
			  </Style>
			  <Style ss:ID="s26" ss:Parent="s19">
			   <Borders>
			    <Border ss:Position="Bottom" ss:LineStyle="Continuous" ss:Weight="1"/>
			    <Border ss:Position="Left" ss:LineStyle="Continuous" ss:Weight="1"/>
			    <Border ss:Position="Right" ss:LineStyle="Continuous" ss:Weight="1"/>
			    <Border ss:Position="Top" ss:LineStyle="Continuous" ss:Weight="1"/>
			   </Borders>
			  </Style>
			  <Style ss:ID="s27">
			   <Alignment ss:Horizontal="Center" ss:Vertical="Bottom"/>
			   <Borders>
			    <Border ss:Position="Bottom" ss:LineStyle="Continuous" ss:Weight="1"/>
			    <Border ss:Position="Left" ss:LineStyle="Continuous" ss:Weight="1"/>
			    <Border ss:Position="Right" ss:LineStyle="Continuous" ss:Weight="1"/>
			    <Border ss:Position="Top" ss:LineStyle="Continuous" ss:Weight="1"/>
			   </Borders>
			   <Font x:CharSet="204" x:Family="Swiss" ss:Bold="1"/>
			  </Style>
			 </Styles>
			 <Worksheet ss:Name="Тарифы по регионам">
			  <Table x:FullColumns="1"
			   x:FullRows="1">
			   <Column ss:AutoFitWidth="0" ss:Width="21.75"/>
			   <Column ss:AutoFitWidth="0" ss:Width="138"/>
			   <Column ss:AutoFitWidth="0" ss:Width="104.25"/>
			   <Column ss:AutoFitWidth="0" ss:Width="104.25"/>
			   <Column ss:AutoFitWidth="0" ss:Width="54"/>
			   <Column ss:AutoFitWidth="0" ss:Width="54"/>
			`;

			let tabFooter = `  
			  </Table>
			  <WorksheetOptions xmlns="urn:schemas-microsoft-com:office:excel">
			   <PageSetup>
			    <PageMargins x:Bottom="0.984251969" x:Left="0.78740157499999996"
			     x:Right="0.78740157499999996" x:Top="0.984251969"/>
			   </PageSetup>
			   <Print>
			    <ValidPrinterInfo/>
			    <PaperSizeIndex>9</PaperSizeIndex>
			    <HorizontalResolution>1200</HorizontalResolution>
			    <VerticalResolution>1200</VerticalResolution>
			   </Print>
			   <Selected/>
			   <Panes>
			    <Pane>
			     <Number>3</Number>
			     <ActiveRow>6</ActiveRow>
			     <ActiveCol>1</ActiveCol>
			    </Pane>
			   </Panes>
			   <ProtectObjects>False</ProtectObjects>
			   <ProtectScenarios>False</ProtectScenarios>
			  </WorksheetOptions>
			 </Worksheet>
			</Workbook>
			`;   

		tableStr = tabHeader1;
		tableStr += this.renderHeders();
		tableStr += this.renderRegLines();

		tableStr += tabFooter;

        let blob = new Blob([tableStr], { type: 'application/vnd.ms-excel' });
        let link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'Таблица регионов.xls';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
	}

} 

export default MainTable;